// extracted by mini-css-extract-plugin
module.exports = {"ListDataWrrapper":"styles_ListDataWrrapper__5CNIi","ListDataWrrapper_List":"styles_ListDataWrrapper_List__3dAAU"};